// Wishlist System
class Wishlist {
  constructor() {
    this.items = this.getWishlist();
    this.init();
  }

  init() {
    this.updateWishlistCount();
    this.attachEventListeners();
  }

  getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  }

  saveWishlist() {
    localStorage.setItem('wishlist', JSON.stringify(this.items));
    this.updateWishlistCount();
  }

  addToWishlist(product) {
    try {
      const exists = this.items.find(item => item.handle === product.handle);

      if (!exists) {
        this.items.push(product);
        this.saveWishlist();
        this.showNotification('Added to Wishlist!', 'success');
        return true;
      } else {
        this.showNotification('Already in Wishlist', 'info');
        return false;
      }
    } catch (err) {
      console.error('Wishlist add error:', err);
      this.showNotification('Failed to add to wishlist', 'error');
      return false;
    }
  }

  removeFromWishlist(handle) {
    try {
      this.items = this.items.filter(item => item.handle !== handle);
      this.saveWishlist();
      this.showNotification('Removed from Wishlist', 'success');
    } catch (err) {
      console.error('Wishlist remove error:', err);
      this.showNotification('Failed to remove from wishlist', 'error');
    }
  }

  isInWishlist(handle) {
    return this.items.some(item => item.handle === handle);
  }

  updateWishlistCount() {
    const count = this.items.length;
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  attachEventListeners() {
    document.addEventListener('click', (e) => {
      const wishlistBtn = e.target.closest('.wishlist-btn, .quick-btn[title="Add to Wishlist"]');
      if (wishlistBtn) {
        e.preventDefault();
        const productCard = wishlistBtn.closest('.prod-card, .product-card');
        if (productCard) {
          const productData = {
            handle: productCard.dataset.handle,
            title: productCard.dataset.title,
            price: productCard.dataset.price,
            image: productCard.dataset.image,
            url: productCard.dataset.url
          };

          if (this.isInWishlist(productData.handle)) {
            this.removeFromWishlist(productData.handle);
            wishlistBtn.classList.remove('active');
          } else {
            this.addToWishlist(productData);
            wishlistBtn.classList.add('active');
          }
        }
      }
    });

    // Update wishlist button states on page load
    document.querySelectorAll('.prod-card, .product-card').forEach(card => {
      const handle = card.dataset.handle;
      if (handle && this.isInWishlist(handle)) {
        const btn = card.querySelector('.wishlist-btn, .quick-btn[title="Add to Wishlist"]');
        if (btn) btn.classList.add('active');
      }
    });
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `wishlist-notification ${type}`;

    const icon = type === 'success' ? '✓' : 'ℹ';

    notification.innerHTML = `
      <div class="notification-content">
        <span class="notification-icon"></span>
        <span class="notification-message"></span>
      </div>
    `;
    notification.querySelector('.notification-icon').textContent = icon;
    notification.querySelector('.notification-message').textContent = message;

    document.body.appendChild(notification);

    setTimeout(() => notification.classList.add('show'), 100);

    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
}

// Initialize wishlist
document.addEventListener('DOMContentLoaded', () => {
  window.wishlist = new Wishlist();
});
